@for (item of breadcrumbs; track item) {
  @if (!$first) {
    <ng-doc-icon icon="chevron-right"></ng-doc-icon>
  }
  {{ item }}
}
